import { mdiChevronLeft, mdiClose } from '@mdi/js';
import _ from 'lodash';
import React, { useContext } from 'react';
import { MessagingContext } from '../../../services/messaging/context';
import { renderDate } from '../../data-table';
import { authorNickname, MessagingAuthorType } from '../util';
import * as S from './chat-header.styles';

interface IChatHeaderProps {
    onBack?: () => void;
}

export const ChatHeader: React.FunctionComponent<IChatHeaderProps> = ({ onBack }) => {
    const context = useContext(MessagingContext);
    const { message } = context;

    const authorType = _.get(message, 'author.type', '');

    const sourceLabel = (type: MessagingAuthorType): string => {
        switch (type) {
            case MessagingAuthorType.SUPPORT:
                return 'Enter Billing Team';
            case MessagingAuthorType.PROVIDER:
            case MessagingAuthorType.PATIENT:
            default:
                return '';
        }
    };

    const getInitials = (name: string): string => {
        if (!name) return '';
        const parts = name.trim().split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.slice(0, 2).toUpperCase();
    };

    const handleCloseClick = (): void => {
        context.onMessageClose && context.onMessageClose();
    };

    const handleBackClick = (): void => {
        onBack && onBack();
    };

    const nickname = authorNickname(message as any);
    const initials = getInitials(nickname);
    
    return (
        <S.Header>
            {onBack && (
                <S.BackButton onClick={handleBackClick}>
                    <S.BackIcon path={mdiChevronLeft} size={0.83} />
                </S.BackButton>
            )}
            <S.HeaderLabels>
                {message && !!nickname && (
                    <>
                        <S.Avatar>{initials}</S.Avatar>
                        <S.Value>{nickname}</S.Value>
                    </>
                )}
            </S.HeaderLabels>
            <S.CloseButton onClick={handleCloseClick}>
                <S.CloseIcon path={mdiClose} size={0.83} />
            </S.CloseButton>
        </S.Header>
    );
};
